import { render, staticRenderFns } from "./PrescriptionPopup.vue?vue&type=template&id=44b5368e&scoped=true&"
import script from "./PrescriptionPopup.vue?vue&type=script&lang=js&"
export * from "./PrescriptionPopup.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionPopup.vue?vue&type=style&index=0&id=44b5368e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5368e",
  null
  
)

export default component.exports